<template>
  <div>
    <Card>
      <div class="search-con search-con-top">
        <Form :model="form" :label-width="80" inline>
          <FormItem label="异常类型">
            <Input v-model="form.errorType"></Input>
          </FormItem>
          <FormItem label="异常信息">
            <Input v-model="form.errorMsg"></Input>
          </FormItem>
          <FormItem label="状态">
            <Input v-model="form.status"></Input>
          </FormItem>
        </Form>
        <div class="toolbar">
          <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
        </div>
      </div>
      <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
              @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
    </Card>
    <tradeuploaderrorInfo ref="tradeuploaderrorInfoRef" @handle-search="handleSearch"></tradeuploaderrorInfo>
  </div>
</template>

<script>
import tradeuploaderrorInfo from './tradeuploaderror-info'
import { getIds } from '@/libs/util'
import { download } from '@/libs/api.request'

export default {
  name: 'tradeuploaderror-list',
  components: {
    tradeuploaderrorInfo
  },
  data () {
    return {
      columns: [
        { title: '客户id', key: 'customId' },
        { title: '文件ID', key: 'fileId' },
        { title: '上传时间', key: 'uploadTime' },
        { title: '状态', key: 'status' },
        { title: '异常类型', key: 'errorType' },
        { title: '创建人', key: 'crtUserId' },
        { title: '创建时间', key: 'crtTime' },
        {
          title: '操作',
          key: 'handle',
          minWidth: 200,
          options: ['detail'],
          button: [
            (h, params, vm) => {
              return h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  icon: 'md-attach'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.downFile(params.row.fileId)
                  }
                }
              }, '文件下载')
            }]
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        errorType: '',
        errorMsg: ''
      },
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleUpdate (param) {
      this.$refs.tradeuploaderrorInfoRef.openModel('update', param.row)
    },
    handleDetail (param) {
      this.$refs.tradeuploaderrorInfoRef.openModel('detail', param.row)
    },
    handleCreate () {
      this.$refs.tradeuploaderrorInfoRef.openModel('create')
    },
    downFile (fileId) {
      download('api/tradeUploadErrorltd/getFile', { fileId: fileId })
    },
    handleDelete () {
      this.D('tradeUploadError', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      let param = {
        page: page,
        pageSize: pageSize,
        model: this.form
      }
      this.L('tradeUploadErrorltd', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
